import { thunk } from 'easy-peasy';

import api from '~/services/api';
import { IThunkCreateMedicaidPlan } from '../types';

const onCreateMedicaidPlan: IThunkCreateMedicaidPlan = thunk(
  async ({ setMedicaidPlan }, { requestInfo, requestPayload }) => {
    const { data } = await api.medicaidPlan.createMedicaidPlan(requestInfo, requestPayload);
    setMedicaidPlan(data);
    return data;
  },
);

export default onCreateMedicaidPlan;
